export default "__VITE_ASSET__DibpK$Dr__"